import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useJobs } from '../context/JobsContext';
import JobMatchingModal from './JobMatchingModal';

const Hero = () => {
  const navigate = useNavigate();
  const { jobs } = useJobs();
  const [isMatchingModalOpen, setIsMatchingModalOpen] = useState(false);

  const handleFindSuitableJob = (e) => {
    e.preventDefault();
    setIsMatchingModalOpen(true);
  };

  return (
    <>
      <section className="hero">
        <div className="hero-box obj-width">
          <div className="h-left">
            <h1>
              Discover Opportunities <br />
              That Match Your Skills
            </h1>
            <p>
              Work with top companies and <br />
              grow your career with Alacritas
            </p>
            <button 
              className="btn-smart-match"
              onClick={handleFindSuitableJob}
              title="Answer a quick survey to find your perfect job match"
            >
              <span className="icon">✨</span>
              Find Me a Suitable Job
            </button>
          </div>

          <div className="h-right">
          </div>
        </div>
      </section>

      <JobMatchingModal
        isOpen={isMatchingModalOpen}
        onClose={() => setIsMatchingModalOpen(false)}
        jobs={jobs || []}
      />
    </>
  );
};

export default Hero;
